import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import Badge from 'react-bootstrap/Badge';
import { MdPageview } from "react-icons/md";
import { FaBoxOpen, FaRoute, FaUser, FaBuilding, FaCalendarAlt, FaBarcode } from "react-icons/fa";
import FetchApi from '../../customhooks/functionFetchApi';

const PopUpshowDetailbom = (props) => {
    const FetchApis = new FetchApi();

    const [show, setShow] = useState(false);
    const [datalistAll, setDatalistAll] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!show) return;

        async function loadData() {
            setLoading(true);
            const res = await FetchApis.FethcGet(`/registerbom/getRegisterbomByJourId/${props.ids}`);
            setDatalistAll(res?.data?.data || []);
            setLoading(false);
        }

        loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [show]);

    const formatDate = (dateStr) => {
        if (!dateStr) return '-';
        try {
            const d = new Date(dateStr);
            return d.toLocaleDateString('th-TH', { year: 'numeric', month: 'short', day: 'numeric' });
        } catch {
            return dateStr;
        }
    };

    return (
        <>
            <div onClick={() => setShow(true)} style={{ cursor: 'pointer' }}>
                <MdPageview size={35} color='#F08B78' />
            </div>

            <Modal
                show={show}
                onHide={() => setShow(false)}
                size="xl"
                aria-labelledby="detail-bom-modal"
            >
                <Modal.Header closeButton style={{ backgroundColor: '#E9967A', color: '#fff' }}>
                    <Modal.Title id="detail-bom-modal" style={{ fontWeight: 600, fontSize: 16 }}>
                        รายละเอียด BOM / Route
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body style={{ backgroundColor: '#f5f6fa', padding: 20, maxHeight: '80vh', overflowY: 'auto' }}>
                    {loading ? (
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 200 }}>
                            <div className="spinner-border text-warning" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                            <span style={{ marginLeft: 12, color: '#888', fontSize: 14 }}>กำลังโหลดข้อมูล...</span>
                        </div>
                    ) : datalistAll.length === 0 ? (
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: 250, color: '#aaa' }}>
                            <FaBoxOpen size={50} color="#ddd" />
                            <p style={{ marginTop: 16, fontSize: 14 }}>ไม่มีข้อมูลการลงทะเบียนสร้าง BOM หรือ Route</p>
                        </div>
                    ) : (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
                            {datalistAll.map((item, index) => {
                                const isBom = item.typeregister === 'bom';
                                const accentColor = isBom ? '#28B463' : '#2E86C1';
                                const Icon = isBom ? FaBoxOpen : FaRoute;

                                return (
                                    <div key={index} style={{
                                        backgroundColor: '#fff',
                                        borderRadius: 10,
                                        boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                                        overflow: 'hidden',
                                        border: `1px solid ${accentColor}22`
                                    }}>
                                        {/* Card Header */}
                                        <div style={{
                                            backgroundColor: accentColor,
                                            padding: '10px 16px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 10
                                        }}>
                                            <Icon size={18} color="#fff" />
                                            <span style={{ color: '#fff', fontWeight: 600, fontSize: 14 }}>
                                                {isBom ? 'Bill of Materials (BOM)' : 'Routing'}
                                            </span>
                                            <Badge bg="light" text="dark" style={{ marginLeft: 'auto', fontSize: 12 }}>
                                                {item.typeregister}
                                            </Badge>
                                        </div>

                                        {/* Meta Info */}
                                        <div style={{
                                            display: 'flex',
                                            flexWrap: 'wrap',
                                            gap: 0,
                                            padding: '14px 16px',
                                            fontSize: 13
                                        }}>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginRight: 24, marginBottom: 6 }}>
                                                <FaBarcode size={13} color={accentColor} />
                                                <span style={{ color: '#666' }}>รหัสเวอร์ชัน :</span>
                                                <span style={{ fontWeight: 600, color: '#333' }}>{item.versionname || '-'}</span>
                                            </div>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginRight: 24, marginBottom: 6 }}>
                                                <FaUser size={13} color={accentColor} />
                                                <span style={{ color: '#666' }}>ผู้ลงทะเบียน :</span>
                                                <span style={{ fontWeight: 600, color: '#333' }}>{item.nameregister || '-'}</span>
                                            </div>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginRight: 24, marginBottom: 6 }}>
                                                <FaBuilding size={13} color={accentColor} />
                                                <span style={{ color: '#666' }}>แผนก :</span>
                                                <span style={{ fontWeight: 600, color: '#333' }}>{item.departments || '-'}</span>
                                            </div>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 6 }}>
                                                <FaCalendarAlt size={13} color={accentColor} />
                                                <span style={{ color: '#666' }}>วันที่บันทึก :</span>
                                                <span style={{ fontWeight: 600, color: '#333' }}>{formatDate(item.dateupdate)}</span>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </Modal.Body>
            </Modal>
        </>
    );
};

export default PopUpshowDetailbom;
